import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const CTAButtons = ({ requestToDemoPath = "/live-demo" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onGetStarted = () => {
    window.location.assign("https://web.dizlog.com/sign-up");
  };

  const handleRequestDemo = () => {
    window.location.href = requestToDemoPath;
  };

  return (
    <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
      <button
        className="btn-primary"
        onClick={onGetStarted}
      >
        {t("Try for Free")}
      </button>
      <button
        className="btn-secondary"
        onClick={handleRequestDemo}
      >
        {t("Book a Demo")}
      </button>
    </div>
  );
};

export default CTAButtons;
